export default __webpack_public_path__ + "static/media/DSIL.eb64b96a.png";